export class NotebookSession {
    'id';
    'notebookId';
    'engineId';
    'userId';
    'status';
    'kernelId';
    'createdAt';
    'lastActivityAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "notebookId",
            "baseName": "notebookId",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineId",
            "baseName": "engineId",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "NotebookSessionStatus",
            "format": ""
        },
        {
            "name": "kernelId",
            "baseName": "kernelId",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastActivityAt",
            "baseName": "lastActivityAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return NotebookSession.attributeTypeMap;
    }
    constructor() {
    }
}
